module.exports = __webpack_public_path__ + "static/img/short2.d90d791.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/short2.png
// module id = XF7N
// module chunks = 1